<template>
  <div class="col-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="基础设置" name="1" class="">
        <div class="content">
          <div>
            <el-checkbox v-model="limitSubNumber">限制二级菜单最大数量</el-checkbox>
            <div class="content-item card mt8" v-if="limitSubNumber">
              <div class="verticallyCenter">
                <span class="mr16">最大数量</span>
                <div class="verticallyCenter set-box">
                  <input
                    class="el-input__inner"
                    type="number"
                    @focus="getFocus($event)"
                    style="width: 68px; height: 32px; flex: 1"
                    min="1"
                    max="10"
                    v-model="maxSubNumber"
                  />
                  <div class="btn-wrapper">
                    <span
                      :class="maxSubNumber === 1 ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
                      @click="changeSubLen(0)"
                    ></span>
                    <span
                      :class="
                        maxSubNumber === options.selectOptions.length
                          ? 'disabled num-btn icon-portal-plus'
                          : 'num-btn icon-portal-plus'
                      "
                      class="num-btn icon-portal-plus"
                      @click="changeSubLen(1)"
                    ></span>
                  </div>
                </div>
              </div>
              <el-checkbox class="mt8" v-model="showSubMore"
                >显示更多按钮<i class="tips-btn icon-portal-info2" @click="explainDialogClick('nav')"></i
              ></el-checkbox>
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="request_prefix !== 'bigScreen' && pageType !== 'listPage' && !!options.appId"
        title="子页面设置"
        name="2"
        class="padding0"
      >
        <div class="content">
          <collapsibleItem :name="collapse.list.title" :type="collapse.list.type" :is-active="collapse.list.isActive">
            <div slot="heading">{{ collapse.list.title }}</div>
            <div slot="body">
              <div>
                <div class="cover layoutConfig-card mt8">
                  <img class="img-box" :src="currentListPageCover" />
                  <div class="footer">
                    <div :title="currentListPageTitle" class="title">{{ currentListPageTitle }}</div>
                  </div>
                </div>
                <div class="mt8 mb12 content-item">
                  <el-checkbox v-model="listPageOpenBlank">新页面打开</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click="explainDialogClick('open')"></i>
                </div>
                <div
                  :class="isListPageEditStatus ? 'is_disabled childPageSettingBtn mt8' : 'childPageSettingBtn mt8'"
                  @click="editPageHandle(true)"
                >
                  <span v-if="isListPageEditStatus" class="icon icon-portal-loading1"></span>
                  <span>{{ subpageSetting.listPageIsUseSystemTemplate ? "查看" : "编辑" }}列表页</span>
                </div>
              </div>
            </div>
          </collapsibleItem>
          <collapsibleItem
            :name="collapse.detail.title"
            :type="collapse.detail.type"
            :is-active="collapse.detail.isActive"
          >
            <div slot="heading">{{ collapse.detail.title }}</div>
            <div slot="body">
              <div>
                <div class="cover layoutConfig-card mt8">
                  <img class="img-box" :src="currentDetailPageCover" />
                  <div class="footer">
                    <div :title="currentDetailPageTitle" class="title">{{ currentDetailPageTitle }}</div>
                  </div>
                </div>
                <div class="mt8 mb12 content-item">
                  <el-checkbox v-model="detailPageOpenBlank">新页面打开</el-checkbox>
                  <i class="tips-btn icon-portal-info2" @click="explainDialogClick('open')"></i>
                </div>
                <div
                  :class="[
                    isDetailPageEditStatus ? 'is_disabled childPageSettingBtn mt8' : 'childPageSettingBtn mt8',
                    navAllDataEmpty ? 'disabledBtn' : ''
                  ]"
                  @click="editDetailPageHandle(true)"
                >
                  <span v-if="isDetailPageEditStatus" class="icon icon-portal-loading1"></span>
                  <span>{{ subpageSetting.detailPageIsUseSystemTemplate ? "查看" : "编辑" }}详情页</span>
                </div>
              </div>
            </div>
          </collapsibleItem>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="request_prefix !== 'bigScreen' && pageType !== 'listPage' && !!options.appId"
        title="高级设置"
        name="3"
        class="padding0"
      >
        <div class="content">
          <collapsibleItem
            :name="collapse.advanced.title"
            :type="collapse.advanced.type"
            :is-active="collapse.advanced.isActive"
          >
            <div slot="heading">{{ collapse.advanced.title }}</div>
            <div slot="body">
              <div>
                <div class="content-item">
                  <el-checkbox v-model="openDataLimit">数据访问限制</el-checkbox>
                  <div class="layoutConfig-card mt8" v-if="openDataLimit">
                    <div class="config-content">
                      <el-radio-group v-model="checkIp">
                        <div class="content-item mb12">
                          <el-radio label="1">仅登录后可访问</el-radio>
                        </div>
                        <div class="content-item mb12">
                          <el-radio label="2">仅IP内可访问</el-radio>
                        </div>
                        <div class="content-item mb12">
                          <el-radio label="3">IP内可访问，IP外需要登录后访问</el-radio>
                        </div>
                      </el-radio-group>
                    </div>
                  </div>
                </div>
                <div class="content-item mt12">
                  <el-checkbox v-model="openSensitiveWords">开启敏感词审核</el-checkbox>
                </div>
                <div class="content-item mt12">
                  <el-checkbox v-model="deliverMhParams">携带系统参数</el-checkbox>
                </div>
                <data-push class="mt12" :options="options"></data-push>
              </div>
            </div>
          </collapsibleItem>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>{{ explainTitle }}：</span>{{ explainTips }}
      </p>
      <div v-if="explainImgSrc || explainVideoSrc" class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { findTabs, replaceUrlParam, handleFindLayoutComponentBoxOptions, handleFindLayoutComponentAllUid } from "utils"
import { layout_title_drawer_button_children } from "materials/button/menus"
import { getAppointCacheData } from "utils/updateData/publicDataUtils/getRestClassify.js"
import {
  createSubPageHandle,
  updateSubPageMapping,
  addSubPageMapping
} from "utils/updateData/publicDataUtils/subPageUpdateData.js"
import dataPush from "components/toolbar-option-components/utilsComponents/dataPush/dataPush.vue"
export default {
  components: {
    dataPush
  },
  props: {
    options: { type: Object },
    container_id: { type: [Number, String] },
    rect_id: { type: [Number, String] }
  },
  watch: {
    openDataLimit: {
      handler: function (val) {
        this.highSet()
      },
      deep: false
    },
    openSensitiveWords: {
      handler: function (val) {
        this.highSet()
      },
      deep: false
    },
    checkIp: {
      handler: function () {
        this.highSet()
      },
      deep: false
    },
    deliverMhParams: {
      handler: function () {
        this.highSet()
      },
      deep: false
    },
    "subpageSetting.listPageTemplateId": {
      handler: function (val) {
        this.getListSubpageInfo(val)
      },
      deep: false
    },
    "subpageSetting.detailPageTemplateId": {
      handler: function (val) {
        this.getDetailSubpageInfo(val)
      },
      deep: false
    }
  },
  data() {
    return {
      this1: this,
      activeNames: ["1", "2", "3"],
      drawerSelectOptions: [
        {
          label: "页面",
          value: true
        },
        {
          label: "组件",
          value: false
        }
      ],
      collapse: {
        top: {
          title: "标题栏",
          type: "top",
          isActive: true
        },
        bottom: {
          title: "底部栏",
          type: "bottom",
          isActive: true
        },
        left: {
          title: "左侧栏",
          type: "left",
          isActive: true
        },
        right: {
          title: "右侧栏",
          type: "right",
          isActive: true
        },
        list: {
          title: "列表页",
          type: "list",
          isActive: true
        },
        detail: {
          title: "详情页",
          type: "detail",
          isActive: true
        },
        advanced: {
          title: "数据设置",
          type: "advanced",
          isActive: true
        }
      },
      currentListPageCover: "",
      currentListPageTitle: "",
      currentDetailPageCover: "",
      currentDetailPageTitle: "",
      publicId: null,
      subPageSettingIndex: 0,
      explainDialog: false,
      explainTitle: "",
      explainTips: "",
      explainImgSrc: "",
      explainVideoSrc: "",
      getAllDetailData: false,
      navAllDataEmpty: false,
      navAllDataFirstId: undefined,
      isListPageEditStatus: false,
      isDetailPageEditStatus: false
    }
  },
  computed: {
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    ids() {
      return this.$store.state.states.activeID
    },
    openDataLimit: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "openDataLimit", "openDataLimit", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "openDataLimit", false)
      }
    },
    checkIp: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "checkIp", "checkIp", "1")
      },
      set(val) {
        this.$changeOptionsEV(val, "checkIp", false)
      }
    },
    openSensitiveWords: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "openSensitiveWords", "openSensitiveWords", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "openSensitiveWords", false)
      }
    },
    deliverMhParams:{
      get() {
        return this.checkAndSetPrimaryVal(this.options, "deliverMhParams", "deliverMhParams", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "deliverMhParams", false)
      }
    },
    limitSubNumber: {
      get() {
        return this.options.hasOwnProperty("limitSubNumber") ? this.options.limitSubNumber : false
      },
      set(val) {
        this.$changeOptionsEV(val, "limitSubNumber", false)
      }
    },
    maxSubNumber: {
      get() {
        return this.options.hasOwnProperty("maxSubNumber") ? this.options.maxSubNumber : 7
      },
      set(val) {
        this.$changeOptionsEV(val, "maxSubNumber", false)
      }
    },
    showSubMore: {
      get() {
        return this.options.hasOwnProperty("showSubMore") ? this.options.showSubMore : false
      },
      set(val) {
        this.$changeOptionsEV(val, "showSubMore", false)
      }
    },
    /**
     * ========列表页配置项===========
     */
    listPageSetting() {
      if (!this.options.appId) return
      const index = this.$store.state[this.request_prefix].page?.subPages?.findIndex(
        item => item.appId === this.options.appId
      )
      if (typeof index === "undefined" || index === -1) return
      return this.$store.state[this.request_prefix].page?.subPages[index].listPageSetting
    },
    listPageOpenBlank: {
      get() {
        return this.listPageSetting?.listPageOpenBlank || true
      },
      set(val) {
        if (this.subPageSettingIndex === -1) return
        let temp = JSON.parse(JSON.stringify(this.$store.state[this.request_prefix].page?.subPages))
        temp[this.subPageSettingIndex].listPageSetting.listPageOpenBlank = val
        updateSubPageMapping.call(this, temp)
        // 每次更新完子页面配置后需要手动触发一次保存
        this.saveDataHandle()
      }
    },
    /**
     * ========详情页配置项===========
     */
    detailPageSetting() {
      if (!this.options.appId) return
      const index = this.$store.state[this.request_prefix].page?.subPages?.findIndex(
        item => item.appId === this.options.appId
      )
      if (typeof index === "undefined" || index === -1) return
      return this.$store.state[this.request_prefix].page?.subPages[index].detailPageSetting
    },
    detailPageOpenBlank: {
      get() {
        return this.detailPageSetting?.detailPageOpenBlank || true
      },
      set(val) {
        if (this.subPageSettingIndex === -1) return
        let temp = JSON.parse(JSON.stringify(this.$store.state[this.request_prefix].page?.subPages))
        temp[this.subPageSettingIndex].detailPageSetting.detailPageOpenBlank = val
        updateSubPageMapping.call(this, temp)
        // 每次更新完子页面配置后需要手动触发一次保存
        this.saveDataHandle()
      }
    },
    // 判断当前是双端环境
    isDounbleEnd() {
      const page = this.$store.state[this.request_prefix].page
      if (page.isPhoneFullScreen || page.isOnlyH5Template) {
        return false
      }
      return true
    },
    subpageSetting() {
      const subPages = this.$store.state[this.request_prefix].page.subPages || []
      const subPage = subPages.find(item => item.appId === this.options.appId) || {}
      return subPage
    }
  },
  mounted() {
    this.getAllDetailDataFunc()
  },
  created() {
    this.initSubPageSetting()
    this.getPublicId()
  },
  methods: {
    checkMenuTriggerType(type) {
      const titleOption = this.options.titleOptions.find(item => item.type === (type === "L" ? "left" : "right"))
      const directionIndex = type === "L" ? 2 : 3
      for (let i = 0; i < titleOption.elementOptions.length; i++) {
        if (titleOption.elementOptions[i].innerElement.includes("Menu")) {
          const completeParam = {
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id,
            directionIndex,
            elementInLayoutId: titleOption.elementOptions[i].elementInLayoutId,
            option_name: "menuTrigger",
            option_val: "click"
          }
          this.$store.dispatch(this.request_prefix + "/changeTitleOptions", completeParam)
        }
      }
    },
    checkboxDisplayHandle(flag, direction, elementParam) {
      let titleOptions = JSON.parse(JSON.stringify(this.options.titleOptions))
      this.titleComponents[direction].elementOptions.find(
        it => it.elementInLayoutId === elementParam.elementInLayoutId
      ).isShow = flag
      // 当改变显示位置时，需要将其他的显示位置设置为不显示,当取消显示位置时，需要将其他的显示位置设置为显示
      this.titleComponents.forEach((element, i) => {
        if (i !== direction) {
          element.elementOptions.forEach((item, j) => {
            if (item.type === elementParam.type) {
              if (flag) {
                item.disabled = true
              } else {
                item.disabled = false
              }
            }
          })
        }
      })
      const { directionIndex, elementInLayoutId } = findTabs(
        this.options,
        {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        },
        elementParam.type
      )
      if (direction === directionIndex && elementParam.elementInLayoutId === elementInLayoutId) {
        // 说明是原来的位置，不需要改变
        titleOptions[direction].elementOptions.find(it => it.elementInLayoutId === elementInLayoutId).isShow = flag
      } else if (this.options.titleOptions[directionIndex]) {
        // 说明是新的位置，需要改变
        const elementComponent = JSON.parse(
          JSON.stringify(
            this.options.titleOptions[directionIndex].elementOptions.find(
              it => it.elementInLayoutId === elementInLayoutId
            )
          )
        )
        if (elementComponent.isShow === true && direction !== directionIndex) return
        // 同时返回数组下标
        const elementComponentIndex = this.options.titleOptions[directionIndex].elementOptions.findIndex(
          it => it.elementInLayoutId === elementInLayoutId
        )
        titleOptions[directionIndex].elementOptions.splice(elementComponentIndex, 1) // 删除原来的位置
        titleOptions[direction].elementOptions.push(elementComponent) // 添加到新的位置并且需要更新elementInLayoutId
        if (titleOptions[direction].elementOptions.length > 1) {
          titleOptions[direction].elementOptions.sort((a, b) => a.elementInLayoutId - b.elementInLayoutId) // 排序
          const newElementInLayoutId =
            titleOptions[direction].elementOptions[titleOptions[direction].elementOptions.length - 1]
              .elementInLayoutId + 1 // 最后一个元素的位置加1
          elementComponent.elementInLayoutId = newElementInLayoutId
          titleOptions[direction].elementOptions.find(it => it.elementInLayoutId === newElementInLayoutId).isShow = flag
        } else {
          titleOptions[direction].elementOptions.find(it => it.elementInLayoutId === elementInLayoutId).isShow = flag
        }
      }
      // 更多按钮不能正确显示在左右两侧
      if (flag === true && (direction === 2 || direction === 3) && elementParam.type === "more") {
        let options = titleOptions[direction].elementOptions.find(it => it.type === elementParam.type).options
        if (options.leftType != "%")
          titleOptions[direction].elementOptions.find(it => it.type === elementParam.type).options.left = 0
      }
      if (flag === true && (direction === 0 || direction === 1) && elementParam.type === "more") {
        let options = titleOptions[direction].elementOptions.find(it => it.type === elementParam.type).options
        if (options.leftType != "%") {
          if (this.request_prefix === "appStage") {
            titleOptions[direction].elementOptions.find(it => it.type === elementParam.type).options.left = 322
          } else {
            titleOptions[direction].elementOptions.find(it => it.type === elementParam.type).options.left = 660
          }
        }
      }
      console.log("titleOptions", titleOptions)
      this.$changeOptionsEV(titleOptions, "titleOptions", false, false, false, true)
    },
    // 查看列表页
    editPageHandle(flag) {
      this.isListPageEditStatus = true
      requestIdleCallback(
        () => {
          // 兼容以前旧模版中的应用 没有子页面映射关系 取第一个模版
          if (this.subPageSettingIndex === -1) {
            this.subPageSettingIndex = 0
          }
          const subPage = this.$store.state[this.request_prefix].page?.subPages[this.subPageSettingIndex]
          const { listPageId, listPageIsUseSystemTemplate } = subPage
          const { appId } = this.options
          this.getListPageUrl().then(res => {
            if (!res.exit && !listPageIsUseSystemTemplate) {
              // 兼容历史数据，子页面不存在但是使用模板标识又为false
              if (!flag) {
                this.isListPageEditStatus = false
                return
              }
              // 不在该网站下, 需要创建自定义页面
              createSubPageHandle
                .call(this, appId, "listPage", listPageId)
                .then(res => {
                  if (res.code === 200) {
                    this.editPageHandle(false)
                  }
                })
                .catch(err => {
                  // 需要创建自定义页面
                  createSubPageHandle
                    .call(this, appId, "listPage")
                    .then(res => {
                      if (res.code === 200) {
                        this.editPageHandle(false)
                      }
                    })
                    .catch(err => {
                      this.isDetailPageEditStatus = false
                    })
                })
            } else {
              if (this.isDounbleEnd) {
                const pcSubPage = (this.$store.state.stage.page.subPages || []).find(
                  item => item.appId === this.options.appId
                )
                const appSubPage = (this.$store.state.appStage.page.subPages || []).find(
                  item => item.appId === this.options.appId
                )
                if (pcSubPage) {
                  window.localStorage.setItem("subPageSetting-" + appId + "-stage", JSON.stringify(pcSubPage))
                }
                if (appSubPage) {
                  window.localStorage.setItem("subPageSetting-" + appId + "-appStage", JSON.stringify(appSubPage))
                }
              } else {
                const subPage = this.$store.state[this.request_prefix].page.subPages[this.subPageSettingIndex]
                window.localStorage.setItem(
                  "subPageSetting-" + appId + "-" + this.request_prefix,
                  JSON.stringify(subPage)
                )
              }
              // pv表示处于预览模式
              const engineInstanceId = this.options.engineInstanceId
              const name = this.options.name
              const url = res.exit
                ? res.url + `&e=${engineInstanceId}&name=${name}`
                : res.url + `&e=${engineInstanceId}&name=${name}&pv=1`
              window.open(url, "_blank")
            }
          })
        },
        { timeout: 500 }
      )
    },
    // 查找列表页是否在当前网站下
    getListPageUrl() {
      const subPage = this.$store.state[this.request_prefix].page?.subPages[this.subPageSettingIndex]
      const { listPageId, listPageIsUseSystemTemplate } = subPage
      const { appId } = this.options
      // 是否是系统页面
      let newUrl = replaceUrlParam(window.location.href, "p", listPageId)
      // 判断当前页面是否在该网站下
      let contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
      const { websiteId, pageId, sign, wfwfid } = this.$store.state.states.getDataPageIds
      return this.$API
        .queryEditPageList({
          websiteId: websiteId,
          pageId: pageId
        })
        .then(res => {
          this.isListPageEditStatus = false
          if (res.data.code === 1) {
            const pageIdList = res.data.data.allPage.map(item => item.publicId)
            // 在该网站下
            newUrl = newUrl + `&a=${appId}&hp=${pageId}`
            const managerType = this.$store.state.states?.managerType
            newUrl = managerType == 1 ? replaceUrlParam(newUrl, "managerType", 1) : newUrl
            if (pageIdList.includes(listPageId)) {
              window.localStorage.setItem("isNavComponent", true)
              return {
                exit: 1,
                url: newUrl
              }
            } else {
              return {
                exit: 0,
                url: newUrl
              }
            }
          }
        })
        .catch(err => {
          this.isListPageEditStatus = false
        })
    },
    // 查看详情页
    editDetailPageHandle(flag) {
      // 空数据不能跳转
      if (this.navAllDataEmpty) {
        this.$message({
          type: "error",
          customClass: "msg_noIcon",
          duration: 3000,
          message: "请先到数据后台导入详情页数据"
        })
        return
      }
      this.isDetailPageEditStatus = true
      requestIdleCallback(
        () => {
          // 兼容以前旧模版中的应用 没有子页面映射关系 取第一个模版
          if (this.subPageSettingIndex === -1) {
            this.subPageSettingIndex = 0
          }
          const subPage = this.$store.state[this.request_prefix].page?.subPages[this.subPageSettingIndex]
          const { detailPageId, detailPageIsUseSystemTemplate } = subPage
          const { appId } = this.options
          this.getDetailPageUrl().then(res => {
            if (!res.exit && !detailPageIsUseSystemTemplate) {
              // 兼容历史数据，子页面不存在但是使用模板标识又为false
              if (!flag) {
                this.isDetailPageEditStatus = false
                return
              }
              // 不在该网站下, 需要创建自定义页面
              createSubPageHandle
                .call(this, appId, "detailPage", detailPageId)
                .then(res => {
                  if (res.code === 200) {
                    this.editDetailPageHandle(false)
                  }
                })
                .catch(err => {
                  // 需要创建自定义页面
                  createSubPageHandle
                    .call(this, appId, "detailPage")
                    .then(res => {
                      if (res.code === 200) {
                        this.editDetailPageHandle(false)
                      }
                    })
                    .catch(err => {
                      this.isDetailPageEditStatus = false
                    })
                })
            } else {
              if (this.isDounbleEnd) {
                const pcSubPage = (this.$store.state.stage.page.subPages || []).find(
                  item => item.appId === this.options.appId
                )
                const appSubPage = (this.$store.state.appStage.page.subPages || []).find(
                  item => item.appId === this.options.appId
                )
                if (pcSubPage) {
                  window.localStorage.setItem("subPageSetting-" + appId + "-stage", JSON.stringify(pcSubPage))
                }
                if (appSubPage) {
                  window.localStorage.setItem("subPageSetting-" + appId + "-appStage", JSON.stringify(appSubPage))
                }
              } else {
                const subPage = this.$store.state[this.request_prefix].page?.subPages[this.subPageSettingIndex]
                window.localStorage.setItem(
                  "subPageSetting-" + appId + "-" + this.request_prefix,
                  JSON.stringify(subPage)
                )
              }
              // pv表示处于预览模式
              const engineInstanceId = this.options.engineInstanceId
              const name = this.options.name
              const url = res.exit
                ? res.url + `&e=${engineInstanceId}&name=${name}`
                : res.url + `&e=${engineInstanceId}&name=${name}&pv=2`
              window.open(url, "_blank")
            }
          })
        },
        { timeout: 500 }
      )
    },
    // 查找详情页是否在当前网站下
    async getDetailPageUrl() {
      const subPage = this.$store.state[this.request_prefix].page?.subPages[this.subPageSettingIndex]
      const { detailPageId, detailPageIsUseSystemTemplate } = subPage
      const { appId } = this.options
      let newUrl = replaceUrlParam(window.location.href, "p", detailPageId)
      // 找到第一个分类的id
      let colsIds = []
      handleFindLayoutComponentAllUid(this.options.rows, colsIds)
      let dataId = 0
      let { engineInstanceId } = this.options
      let temp = 0
      let selectOptions = this.options.selectOptions
      if (selectOptions && selectOptions.length > 0) {
        if (selectOptions[0].label !== "首页" || selectOptions.length === 1) {
          // 如果第一个分类不是首页或者只有一个分类 就取第一个的publicId
          temp = selectOptions[0].publicId
        } else {
          // 否则取第二个
          temp = selectOptions[1].publicId
        }
      }
      let typeId = temp ? temp : 0
      // 查找第一个分类下的第一条数据
      let res = await this.$API.queryClassifyData({
        t: 0,
        param: {
          e: engineInstanceId,
          t: typeId,
          sw: "",
          p2: 1,
          p: 1,
          ad: true,
          nv: true
        }
      })
      if (res && res.data?.code === 1 && res.data?.data?.datas?.datas) {
        dataId = res.data.data.datas.datas[0]?.publicId
      }
      if (!this.navAllDataEmpty && !dataId) {
        dataId = this.navAllDataFirstId
        //默认传0
        typeId = 0
      }
      // 判断当前页面是否在该网站下
      let contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
      const { websiteId, pageId, sign, wfwfid } = this.$store.state.states.getDataPageIds
      return this.$API
        .queryEditPageList({
          websiteId: websiteId,
          pageId: pageId
        })
        .then(async res => {
          this.isDetailPageEditStatus = false
          if (res.data.code === 1) {
            const pageIdList = res.data.data.allPage.map(item => item.publicId)
            // 在该网站下
            newUrl = newUrl + `&e=${engineInstanceId}&t=${typeId}&d=${dataId}&a=${appId}&hp=${pageId}`
            const managerType = this.$store.state.states?.managerType
            newUrl = managerType == 1 ? replaceUrlParam(newUrl, "managerType", 1) : newUrl
            if (pageIdList.includes(detailPageId)) {
              return {
                exit: 1,
                url: newUrl
              }
            } else {
              return {
                exit: 0,
                url: newUrl
              }
            }
          }
        })
        .catch(err => {
          this.isDetailPageEditStatus = false
        })
    },
    // 触发首页的保存
    saveDataHandle() {
      document.getElementById("savePage").click()
    },
    // 高级设置
    highSet() {
      this.$API
        .updateAppAttr({
          param: {
            publicId: this.publicId,
            openSensitiveWords: this.openSensitiveWords,
            checkIp: this.openDataLimit ? this.checkIp : "",
            deliverMhParams: this.deliverMhParams
          }
        })
        .then(res => {
          // console.log('res :>>',res);
          if (res.data.code === 1) {
          }
        })
    },
    async getPublicId() {
      const { websiteId, pageId, wfwfid } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getRectAttribute(this.ids)
      const appId = rectAttr?.options?.appId
      console.log("rectAttr :>>", rectAttr, appId)
      if (!appId) return
      const { restUrl } = await getAppointCacheData.call(this, pageId, wfwfid, websiteId, appId)
      console.log("restUrl:>>", restUrl)
      this.publicId = restUrl.data.data.engineInstance.publicId
    },
    // 根据当前组件的appId找到page.subPageMapping对应的子页面设置
    async initSubPageSetting() {
      let index = this.$store.state[this.request_prefix].page?.subPages?.findIndex(
        item => item.appId === this.options.appId
      )
      let listPageTemplateId, detailPageTemplateId
      if (typeof index === "undefined" || index === -1) {
        // 需要进行有应用但是没有子页面数据的老数据兼容
        await addSubPageMapping.call(this, this.options.appId, false, true).then(res => {
          const currentIndex = this.$store.state[this.request_prefix].page?.subPages?.findIndex(
            item => item.appId === this.options.appId
          )
          index = currentIndex
          listPageTemplateId = this.$store.state[this.request_prefix].page?.subPages[currentIndex].listPageTemplateId
          detailPageTemplateId =
            this.$store.state[this.request_prefix].page?.subPages[currentIndex].detailPageTemplateId
          this.getSubpageInfo(listPageTemplateId, detailPageTemplateId)
        })
      } else {
        listPageTemplateId = this.$store.state[this.request_prefix].page?.subPages[index].listPageTemplateId
        detailPageTemplateId = this.$store.state[this.request_prefix].page?.subPages[index].detailPageTemplateId
        this.getSubpageInfo(listPageTemplateId, detailPageTemplateId)
      }
      this.subPageSettingIndex = index
    },
    // 获取当前子页面模版的Cover和title
    getSubpageInfo(listPageTemplateId, detailPageTemplateId) {
      this.getListSubpageInfo(listPageTemplateId)
      this.getDetailSubpageInfo(detailPageTemplateId)
    },
    getListSubpageInfo(listPageTemplateId) {
      this.$API
        .queryComponentContent({
          encId: listPageTemplateId
        })
        .then(res => {
          if (res.data.code === 1) {
            this.currentListPageCover = res.data.data.cover
            this.currentListPageTitle = res.data.data.title
          }
        })
    },
    getDetailSubpageInfo(detailPageTemplateId) {
      this.$API
        .queryComponentContent({
          encId: detailPageTemplateId
        })
        .then(res => {
          if (res.data.code === 1) {
            this.currentDetailPageCover = res.data.data.cover
            this.currentDetailPageTitle = res.data.data.title
          }
        })
    },
    explainDialogClick(type) {
      this.explainDialog = true
      switch (type) {
        case "top":
          this.explainTitle = "显示标题栏"
          this.explainTips = "在图文/文本列表的顶部，用来放置标题、分类、装饰元素等的区域"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("assets/images/tipsVideoImg/show-title.png")
          break
        case "left":
          this.explainTitle = "显示左侧栏"
          this.explainTips = "在图文/文本列表的左侧，用来放置标题、分类、装饰元素等的区域"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("assets/images/tipsVideoImg/show-left.png")
          break
        case "right":
          this.explainTitle = "显示右侧栏"
          this.explainTips = "在图文/文本列表的右侧，用来放置标题、分类、装饰元素等的区域"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("assets/images/tipsVideoImg/show-right.png")
          break
        case "bottom":
          this.explainTitle = "显示底部栏"
          this.explainTips = "在图文/文本列表的底部，用来放置分页、分类、装饰元素等的区域"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("assets/images/tipsVideoImg/show-bottom.png")
          break
        case "more":
          this.explainTitle = "显示更多"
          this.explainTips = "在预览页点击点击【更多/查看更多】按钮后，就会进入展示全部数据的列表页"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("assets/images/tipsVideoImg/show-more.png")
          break
        case "open":
          this.explainTitle = "新页面打开"
          this.explainTips = "开启后，若点击对应的列表页，新页面将会在新窗口打开"
          this.explainImgSrc = ""
          this.explainVideoSrc = ""
          break
        default:
      }
    },
    // 选中
    seletTempleteHandler(params) {
      if (params.type === "listPage") {
        this.currentListPageCover = params.cover
        this.currentListPageTitle = params.title
      } else {
        this.currentDetailPageCover = params.cover
        this.currentDetailPageTitle = params.title
      }
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    changeSubLen(flag) {
      let selectOptions = this.options.selectOptions
      if (this.maxSubNumber === 1 && flag === 0) {
        return
      }
      this.maxSubNumber = flag === 0 ? this.maxSubNumber - 1 : this.maxSubNumber + 1
    },
    //  获取详情页数据
    async getAllDetailDataFunc() {
      // 获取所有数据 （分类参数不传），取第一条数据的id
      const { engineInstanceId } = this.options
      let res = await this.$API.queryClassifyData({
        t: 0,
        param: {
          e: engineInstanceId,
          sw: "",
          p2: 1,
          p: 1,
          ad: true,
          nv: true
        }
      })
      if (res && res.data?.code === 1 && res.data?.data?.datas?.datas) {
        this.getAllDetailData = true
        if (res.data?.data?.datas?.datas?.length === 0) {
          this.navAllDataEmpty = true
        } else if (res.data?.data?.datas?.datas?.length > 0) {
          this.navAllDataFirstId = res.data?.data?.datas?.datas[0]?.publicId
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar .card {
  padding: 8px;
}
.toolbar .padding0 ::v-deep .el-collapse-item__content {
  padding: 0 16px 0 16px !important;
}
.childPageSettingBtn {
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  color: var(--themeColor);
  padding: 5px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  &:not(.disabledBtn):hover {
    background: var(--defaultButtonHover);
    cursor: pointer;
  }
  &.is_disabled {
    background: var(--defaultButtonHover);
  }
  .icon-portal-loading1 {
    display: inline-block;
    margin-right: 4px;
    transform: rotate(90deg);
    font-size: 14px;
    color: var(--topOperationAColor);
    vertical-align: middle;
    margin-top: -2px;
    animation: rotation 1s linear infinite;
    &:before {
      color: var(--topOperationAColor);
    }
  }
  &.disabledBtn {
    cursor: not-allowed;
    border: 1px solid var(--themeColorDisabled);
    color: var(--themeColorDisabled);
  }
}
.layoutConfig-card {
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  .img-box {
    width: 100%;
    // height: 122px;
    box-sizing: border-box;
    background-color: rgba(245, 246, 248, 1);
    background-position: top;
    background-size: contain;
    background-clip: padding-box;
    background-repeat: no-repeat;
    background-size: 100%;
    &[src=""] {
      opacity: 0;
    }
  }
  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 12px;
    gap: 9.13px;
    position: absolute;
    width: 100%;
    height: 42px;
    left: 0px;
    bottom: 0px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(14.6087px);
    .title {
      font-size: 13px;
      line-height: 18px;
      color: #000000;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 104px;
    }
    .desc {
      cursor: pointer;
      font-weight: 400;
      font-size: 13px;
      line-height: 18px;
      color: #2b67ff;
      display: flex;
      align-items: center;
    }
  }
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 4px 4px 4px 12px;
    background: #fbfcfd;
    .title {
      font-weight: 500;
      font-size: 13px;
      line-height: 18px;
      color: rgba(0, 0, 0, 0.8);
    }
    .btn {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #2b67ff;
      cursor: pointer;
    }
  }
  .config-content {
    padding: 12px 12px 0 12px;
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.8);
    .el-radio {
      margin-top: 0;
      margin-bottom: 0;
      margin-right: 0;
      white-space: pre-wrap;
    }
    .cx-check-box {
      display: inline-block;
    }
    .tips-btn {
      line-height: 20px;
      margin-top: 0;
    }
  }
}
.cover {
  height: 132px;
}
.tips-btn {
  display: inline-block;
  vertical-align: top;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  font-size: 14px;
  color: var(--thirdTextColor);
  margin-left: 2px;
  cursor: pointer;
  border-radius: 4px;
}
.tips-btn:hover {
  color: var(--themeColor);
}
.msg_noIcon.el-message .el-icon-error {
  display: none;
}
</style>
